import { createFileRoute, redirect } from "@tanstack/react-router";
import CertificationPage from "@/pages/CertificationPage";

export const Route = createFileRoute(
  "/$leaid/_error-wrapper/certification-cycles/$certificationid"
)({
  component: CertificationPage,
  beforeLoad: ({ context, params }) => {
    if (!context.hasRole("ReportsMonthly")) {
      throw redirect({ to: "/$leaid", params: { leaid: params.leaid } });
    }
  },
});
